import { lazy } from 'react'

export const DeactivateUserModalAsync = lazy(() =>
    import('./DeactivateUserModal').then(({ DeactivateUserModal }) => ({
        default: DeactivateUserModal,
    }))
)
